var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgClock = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 14 15",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.333.833a6.667 6.667 0 1 0 0 13.333 6.667 6.667 0 0 0 0-13.333Zm0 12a5.334 5.334 0 1 1 0-10.667 5.334 5.334 0 0 1 0 10.667ZM9.4 7.92 8 7.113V4.166a.667.667 0 1 0-1.333 0V7.58a.434.434 0 0 0 .033.133c.014.04.032.078.053.113.019.038.041.074.067.107l.107.087.06.06 1.733 1a.667.667 0 0 0 .333.086.667.667 0 0 0 .334-1.246H9.4Z"
})));

export default SvgClock;